<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="12" class="text-center text-sm-center mb-4 mb-sm-0">
        <img src="/images/logo1.png" style="max-width:100%; max-height: 100px;" />
      </d-col>
    </d-row>

    <!-- Content -->
    <d-row>
      <d-col lg="12" style="text-align:center;">
        <div class="card-signup">
          <h2 class="page-title" style="text-align: center;padding-bottom: 20px;">Recuperar senha</h2>
          <d-form @submit="checkForm">

            <d-form-row>

              <!-- Email -->
              <d-col md="12" class="form-group">
                <label for="feEmail">Email</label>
                <d-form-input type="email" id="feEmail" v-model="feEmail" placeholder="Email" />
              </d-col>

            </d-form-row>
            <div class="message-error" v-if="errorCustom === 1">
              Preencha todos os campos acima!
            </div>
            <div style="text-align:right;" v-if="!loading">
              <d-button type="submit" class="btn-accent">Enviar email</d-button>
            </div>
            <div style="text-align:right;" v-if="loading">
              <img src="/images/load2.gif" style="height: 20px;" />
            </div>

          </d-form>
        </div>
        <div style="text-align: center;padding-top: 10px;padding-bottom: 20px;">
          <a href="./login">Voltar para login</a>
        </div>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import config from '../config'
import axios from 'axios'
export default {
  name: 'user-forget-password',
  data() {
    return {
      errorCustom: 0,
      loading: false,
      feEmail: null
    };
  },
  methods: {
    checkForm(e) {
      e.preventDefault();
      if (!this.feEmail) {
        this.errorCustom = 1;
        return false;
      }
      this.loading = true
      axios.post(config.serverUrl + '/v1/forgetPassword',
      {
        email: this.feEmail
      },
      {})
      .then((res) => {
        this.loading = false
        if (res.data.response) {
          alert('Verifique seu email (caixa de entrada e spam) para trocar sua senha');
        }
      })
      .catch((error) => {
        this.loading = false
        console.log(error)
      });
      return false;
    },
  },
};
</script>

